import { useMemo } from 'react';
import { IOneofProps } from '../OneOfSvcs';

export const useOneofId = ({ svcGroup }: IOneofProps) => {
  const id = useMemo(() => {
    return svcGroup?.svcs.map((svc) => svc.id)?.join('') || 'oneof';
  }, [svcGroup]);

  return id;
};
